import React, { Component } from 'react';
import * as SimilarTitlesSelector from '../../data/SimilarTitleSelectors';
import { getJsonData, getAvailabilityConfiguration } from '../../data/DataStore';
import { SimilarTitlesCarousel, mapOtsAvailability } from '@novelist/novum-novella-ui';
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import { getAvailability } from '../../data/OtsRequests';


class SimilarTitlesCarouselContainer extends Component {
  constructor() {
    super();

    const titlesCardModel = SimilarTitlesSelector.getSimilarTitles(getJsonData());
    const stateData = titlesCardModel ? titlesCardModel.map((item) => ({
      recommendationReason: item.reason,
      recommendedTitle: {
        ui: item.uniqueId,
        mainTitle: item.title,
        author: item.author,
        bookjacketUrl: item.bookJacket,
        catalogLinkUrl: item.isHeld === false ? null : item.catalogLink,
        description: item.description,
        isHeld: item.isHeld,
        availability: undefined
      }
    })) : [];

    this.state = {
      recommendedTitles: stateData,

    };

    this.availabilityConfiguration = getAvailabilityConfiguration();
  }

  componentWillMount() {
    this.updateAvailability();
  }

  updateAvailability() {
    if (this.state.recommendedTitles.length) {
      let newData = this.state.recommendedTitles;
      // taken first element because in setAvailability we put whole response for each ui 
      Promise.resolve(getAvailability(newData[0].recommendedTitle.ui))
        .then((value) => {
          if (value) {
            newData.map(item => {
              let otsDataForTitle = value.find(titleOts => {
                return titleOts.key === item.recommendedTitle.ui
              });
              item.recommendedTitle.availability = otsDataForTitle ? mapOtsAvailability(otsDataForTitle) : undefined;
            });
            this.setState({ recommendedTitles: newData });
          }
        });
    }
  }

  render() {
    if (this.state.recommendedTitles.length) {
      return (
        <AnalyticsWrapperContainer
          Component={<SimilarTitlesCarousel recommendedTitleList={this.state.recommendedTitles} availabilityConfiguration={this.availabilityConfiguration} />}
          componentName={'Similar Title'}
          featureType={'Title Read-alikes'}
        />
      );
    }
    else {
      return null;
    }
  }
}

export default SimilarTitlesCarouselContainer; 


// WEBPACK FOOTER //
// ./src/react/containers/SimilarTitlesCarouselContainer.jsx